import { notEmpty } from './utils/configUtils';

const config = {
  AppSyncUrl: import.meta.env.VITE_CORE_GRAPHQL_API,
  AppSyncHost: import.meta.env.VITE_APPSYNC_HOST,
  DashboardUrl: import.meta.env.VITE_DASHBOARD_URL,
  Environment: import.meta.env.MODE,
  BaseUrl: import.meta.env.BASE_URL,
  AppVersion: import.meta.env.VITE_APP_VERSION,

  Cognito: {
    Region: import.meta.env.VITE_COGNITO_AWS_REGION,
    UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    IdentityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
    IdpEndpoint: import.meta.env.VITE_COGNITO_IDP_ENDPOINT,
    OauthDomain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
    OauthRedirectSignIn: import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_IN,
    CognitoUri: import.meta.env.VITE_COGNITO_URI,
    RedirectBase: import.meta.env.VITE_COGNITO_REDIRECT_BASE,
    Oauth: {
      Domain: import.meta.env.VITE_COGNITO_DOMAIN,
      Scopes: [
        'email',
        'openid',
        'phone',
        'profile',
        'aws.cognito.signin.user.admin',
      ],
    },
  },
  Datadog: {
    ApplicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    ClientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  },
  ContentGeneration: {
    StreamingUrl: import.meta.env.VITE_STREAMING_URL,
    AssistantTagUrl: import.meta.env.VITE_ASSISTANT_TAG_URL,
  },
  Live: {
    Search: {
      MaxResults: 10,
    },
    Audio: {
      Devices: {
        FallbackInterval: 5000,
      },
      activityChange: {
        activate: 2500,
        deactivate: 6000,
      },
      sessionTimeout: {
        body: 60000,
      },
      noVadDetected: {
        body: 60000,
      },
      MinimumSessionDuration: 60000,
      MinimumSentences: 3,
      MinimumCharacters: 200,
    },
    WebSocketUrl: import.meta.env.VITE_LIVE_WEBSOCKET_URL,
    AudioWebsocketUrl: import.meta.env.VITE_AUDIO_WEBSOCKET_URL,
    ConnectWebSocketUrl: import.meta.env.VITE_LIVE_CONNECT_WEBSOCKET_URL,
  },
  Auth: {
    Url: import.meta.env.VITE_AUTH_URL,
    Cookies: {
      TokenCookieName: import.meta.env.VITE_TOKEN_COOKIE_NAME,
      OrgOverrideCookieName: import.meta.env.VITE_ORG_OVERRIDE_COOKIE_NAME,
      RoleOverrideCookieName: import.meta.env.VITE_ROLE_OVERRIDE_COOKIE_NAME,
      CookieDomain: import.meta.env.VITE_COOKIE_DOMAIN,
      CookiePrefix: import.meta.env.VITE_COOKIE_PREFIX,
    },
  },
  Urls: {
  },
  PushKey: import.meta.env.VITE_PUSH_KEY,
  NotificationCoolDown: 1000 * 8,
  Translation: {
    CookieName: import.meta.env.VITE_TRANSLATION_COOKIE_NAME,
    CookieDomain: import.meta.env.VITE_COOKIE_DOMAIN,
  },
  FeatureFlags: {
    NightlyChannelEnabled: import.meta.env.VITE_ENABLE_NIGHTLY_CHANNEL ?? 'false',
  },
  Roles: {
    User: 1,
    ExpertUser: 2,
    Admin: 3,
    Owner: 6,
  },
  Unleash: {
    url: import.meta.env.VITE_UNLEASH_URL,
    clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY,
    refreshInterval: 60,
    appName: 'live',
    disableMetrics: true,
  },
  AwsRum: {
    AppId: import.meta.env.VITE_AWS_RUM_APP_ID,
    GuestRoleArn: import.meta.env.VITE_AWS_RUM_GUEST_ROLE_ARN,
    Endpoint: import.meta.env.VITE_AWS_RUM_ENDPOINT,
  },
  SupportMail: import.meta.env.VITE_SUPPORT_MAIL,
  Authentication: {
    RedirectProtocol: import.meta.env.VITE_AUTHENTICATION_REDIRECT_PROTOCOL,
  },
};

notEmpty('config', config);

export default config;
